import SelectWithChips from './SelectWithChips'

export default SelectWithChips
